export default __webpack_public_path__ + "static/media/TE_icon_logo.72b1bd5c.svg";